import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=3f72ffd4&scoped=true"
import script from "./userAgreement.vue?vue&type=script&lang=js"
export * from "./userAgreement.vue?vue&type=script&lang=js"
import style0 from "./userAgreement.vue?vue&type=style&index=0&id=3f72ffd4&prod&lang=scss"
import style1 from "./userAgreement.vue?vue&type=style&index=1&id=3f72ffd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f72ffd4",
  null
  
)

export default component.exports